import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import cnchar from 'cnchar';

// require('./mock'); //引入mock数据，关闭则注释该行

import './plugins/axios'
import '@/styles/index.scss' // global css
import '@/styles/date-time-picker.scss' // date-time-picker css
// import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import './icons' // icon
// import './css/override-element-ui.css'
import 'element-ui/lib/theme-chalk/index.css';
import '@/components/flow/DynamicForm/styles/index.styl'
// import '@/components/flow/DynamicForm/icons'
import './plugins/axios'
import './plugins/element.js'
import './plugins/common.js'
import './plugins/moment.js'
import './plugins/permission.js'
import './directives'
import './components'
import './plugins/echarts'
import './plugins/guide'
import './plugins/dayjs'
import './utils/dialog'
import axios from 'axios';
Vue.prototype.$axios = axios;
import jquery from 'jquery'
window.jquery = window.$ = jquery
import ElementUI from 'element-ui';
import func from './plugins/preload.js'
import 'babel-polyfill';
import { Button, Popup, Picker, Icon, Overlay, Swipe, SwipeItem, ActionSheet, Cell } from 'vant'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import FormControls from './components/flow/FormControls/index.js'
// import style
// import 'swiper/css/swiper.css'
import 'swiper/swiper-bundle.css'
import Meta from 'vue-meta'
import nodeWrap from '@/components/flow/newProcess/nodeWrap'
Vue.component('nodeWrap', nodeWrap); //初始化组件
import addNode from '@/components/flow/newProcess/addNode'
Vue.component('addNode', addNode); //初始化组件
Vue.use(Meta)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )

Vue.use(Popup).use(Button).use(Picker).use(Icon).use(Overlay).use(Swipe).use(SwipeItem).use(ActionSheet).use(Cell)
Vue.config.productionTip = false

Vue.use(FormControls)
Vue.use(ElementUI);
Vue.prototype.$func = func;
Vue.prototype.log = console.log

import VueCropper from 'vue-cropper';
Vue.use(VueCropper);

Vue.directive('enterNumber', {
    bind: function(el, { value = 2 }) {
        el = el.nodeName == "INPUT" ? el : el.children[0]
        var RegStr = value == 0 ? `^[\\+\\-]?\\d+\\d{0,0}` : `^[\\+\\-]?\\d+\\.?\\d{0,${value}}`;
        el.addEventListener('keyup', function() {
            el.value = el.value.match(new RegExp(RegStr, 'g'));
            el.dispatchEvent(new Event('input'))
        })
    }
});
Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el) {
        el.focus()
    }
});
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')